import { t } from "i18next";
import { FILE_URL } from "../../config/utils";
import useGetAllData from "../../hooks/useGetAllData";
import VideoApp from "./on_video";

const Instruction = () => {
  const { data } = useGetAllData<any>({ queryKey: ["handbooks"], url: "/handbooks"});

  return (
    <div>
      <div className="flex justify-between my-5"><h2 className="text-2xl font-semibold">{t("Instruction")}</h2></div>
      <div className="flex gap-10">
      {data?.map((item: any, index: number) => (
              <div>
                <VideoApp video_url={`${FILE_URL}/${item?.video?.contentUrl}`}/>
                <p className="mt-2 text-lg font-medium text-gray-500">{item?.title}</p>
            </div>
      ))}
      </div>
    </div>
  );
};

export default Instruction;